export const defaultAnchorLink = '#Form-Open-Acc';

export const primaryButtonText = 'Стать инвестором';

export const dataTestIds = {
    assetRatingContainer: 'asset-rating-container',
    assetRating: 'asset-rating',
    assetThermometersContainer: 'asset-thermometers-container',
    aboutAssetContainer: 'about-asset-container',
    assetHeaderContainer: 'asset-header-container',
};
